import * as React from 'react'
import { styleguide } from 'styleguide'

export default function({ className, color = 'secondary', light }) {
  return (
    <svg
      className={className}
      viewBox="0 0 69 69"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <circle id="pokadot-circle-path-1" cx="62.5" cy="139.5" r="34.5" />
        <pattern
          id="pokadot-circle-pattern-2"
          width="10.2941176"
          height="10.2941176"
          x="17.7058824"
          y="94.7058824"
          patternUnits="userSpaceOnUse">
          <use
            xlinkHref="#pokadot-circle-image-3"
            transform="scale(0.102941176,0.102941176)"
          />
        </pattern>
        <image
          id="pokadot-circle-image-3"
          width="100"
          height="100"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABGdBTUEAA1teXP8meAAAA4BJREFUeAHtnL1uE0EUheMIpSNCkehDg4ASUdBRJBIoDRUFPAg0eYPkMZBSU7hAQEFHAZQBUcADIAEKHUIy54AjpYidWPaeu4O/K938rXfvme/MjKPdGa+sEBCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAJLSmDQUrtHo9EF6b2jvKu8obyq3FBeVDp+Kr8pPykPlc+VrweDwW99JxZBQCasKR8onyq/K2cNn+NzfY21RWhaymsI3kD5SPlZuajwtXzNpmaG8g4gYFvKd8quwtfeKm9o3wUI0qpyrysXTrmua632nUuJPoFZVw5Pgdb1n1xzvaTRfS0qIJvKw67JT7m+a2/2gU/5m5tAuHe+UV4vBvJB9W/rX+SjSh2l86fMcP0DZbUZ9sAaDsaa/PvyhRqffANXuXPFXqUTZVOW0Gyr4S8qGz+l9ramrldTjnd2qMQQmeG6b5U3O2vZfBd+r9NvyZTRfJeZ/eyq95CHktpXM0zR2qwxHvERotHh+0kflVfirZ2t4Be9/JpGya/ZTpvv1RUj5L4k990MU7VGa41GlSHRRs5RLG5IdMrSdOXnGV+Vl+aAlDz1h4pd1rQVe56SHiF+uNSKGTbeWq05FmlD7sVatrhCfjoZi7QhfbhFMitcPyqORdoQPwNvLaKa04ZstOaG9EY1pw05Xh3Ski9RzWlDWjKiRGvaEK+bai2imtOGeBFbaxHVnDbEKwpbi6jmtCFe3tlaRDWnDfFa29Yiqpmbi9O7x/99c3F813Q4nUGvjg6Td3rd8vSU5ZrP/KWRiGuNTlk2gUe407tifISMn1HvTpfVi6O7Y61RMfER4taxDGiyx/ERYinqeV7v9GSyrPIjj8ca40JKDHEr1eCX+rYfb/HZBfelrWTV4tnSOn6Fpi5v0KnYE6Kyp4a1lHVS4y55DznpswCwHeEEkNLe8LdH/NuPsaOfvT+jKlx7R1PVUZWA3tX1SFFWTF9saZvUGzx/K5N7Rtj0OcmMk3+XKdvKrrdFe38KcV4CMoQPDjgvrOTrZMxSfbRG+b+9s5grc44/fMZLUr0K0ovYvG7qeKkOHz4jGAQEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIBAkwT+AIm4HsZAOexlAAAAAElFTkSuQmCC"
        />
      </defs>
      <g
        id="pokadot-circle-Desktop-Copy-4"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd">
        <g
          id="pokadot-circle-Desktop-Home-Copy-9"
          transform="translate(-699.000000, -626.000000)">
          <g
            id="pokadot-circle-Group-40"
            transform="translate(671.000000, 521.000000)">
            <g id="pokadot-circle-Group-39-Copy-2">
              <g id="pokadot-circle-Group-20-Copy-3">
                <g id="pokadot-circle-Group-17">
                  <g id="pokadot-circle-Oval-7-Copy-2">
                    <use
                      fill={styleguide.colors[color]}
                      xlinkHref="#pokadot-circle-path-1"
                    />
                    <use
                      fill-opacity={light ? 0.5 : 0.1}
                      fill="url(#pokadot-circle-pattern-2)"
                      xlinkHref="#pokadot-circle-path-1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/Illustrations/PokadotCircle.jsx